import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_MEMBER_LANG: {
  STUDY_MEMBER_INVITATION_TITLE: MvnCodeFE;
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_JOIN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_JOIN_NOUN: MvnCodeFE;
  STUDY_MEMBER_STATUS_INVITED: MvnCodeFE;
  STUDY_MEMBER_STATUS_REGISTERED: MvnCodeFE;
  MEMBERS_TAB: MvnCodeFE;
  ROLES_TAB: MvnCodeFE;
} = {
  STUDY_MEMBER_INVITATION_TITLE: {
    ko: "[Maven Converter]에 초대되었습니다.",
    en: "You’ve been invited to [Maven Converter].",
  },
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: {
    ko: "스터디 이름",
    en: "Study Name",
  },
  STUDY_MEMBER_INVITATION_CONTENT: {
    ko: "{inviter} ({inviterEmail}) 께서 귀하를 Maven Converter의 {studyName} 에 초대했습니다.",
    en: "{inviter} ({inviterEmail}) has invited you to join the {studyName} in Maven Converter.",
  },

  STUDY_MEMBER_INVITATION_CONTENT_JOIN: {
    ko: "Join 버튼을 클릭하여 초대받은 스터디를 확인할 수 있습니다.",
    en: "Press the 'Join' button to access the study.",
  },
  STUDY_MEMBER_INVITATION_JOIN_NOUN: {
    ko: "Join",
    en: "Join",
  },
  STUDY_MEMBER_STATUS_INVITED: {
    ko: "초대됨",
    en: "Invited",
  },
  STUDY_MEMBER_STATUS_REGISTERED: {
    ko: "등록됨",
    en: "Registered",
  },
  MEMBERS_TAB: {
    ko: "Members",
    en: "Members",
  },
  ROLES_TAB: {
    ko: "Roles",
    en: "Roles",
  },
};
//
MvnCodeInitiate(CONVERTER_STUDY_MEMBER_LANG);
